/*
 * Public API Surface of oicl-openbridge
 */

export * from './oicl-openbridge.service';
export * from './plugin-initializer';
